export default {
  // Header
  "nav": {
    "home": "Home",
    "services": "Services",
    "quickOrder": "Quick Order",
    "faq": "FAQ",
    "contact": "Contact",
  },

  // Footer
  "footer": {
    "copyright": "© 2023 GamiFly Tech. All rights reserved.",
  },

  // Homepage
  "home": {
    "hero": {
      "headline": "Your ideas, brought to life. Fast, affordable, professional.",
      "subheadline": "Get your demo in as fast as 24 hours. At a price that works for you.",
      "cta": "Start Your Project"
    },
    "trust": {
      "fast": "24h Fast Delivery",
      "price": "Affordable",
      "team": "Professional Quality"
    },
    "stats": {
      "delivery": "Fast Delivery",
      "proNumber": "Pro",
      "proLabel": "Tech Team",
      "priceNumber": "Best",
      "priceLabel": "Price Guarantee"
    },
    "howItWorks": {
      "title": "Your Journey With Us",
      "step1": "Share your needs",
      "step2": "Receive your demo within 24 hours",
      "step3": "Pay only when you're satisfied",
      "step4": "Get ongoing support for your project",
    },
    "howItWorksDescription": "A simple, efficient process designed to bring your vision to life exactly as you imagined it.",
    "whyChooseUs": "Benefits For You",
    "whyChooseUsSubtitle": "Everything you need to turn your software vision into reality - fast and affordably.",
    "quickOrder": {
      "title": "Ready to Start Your Project?",
      "subtitle": "Share your needs and receive your demo and quote within 24 hours."
    }
  },

  // Trust Section
  "trust": {
    "title": "Why You Can Trust Us",
    "subtitle": "Your project deserves the best - here's how we deliver it",
    "case": {
      "title": "More than 95% Satisfied Clients Across Industries",
      "description": "Your project benefits from our experience delivering solutions for finance, retail, education, and more."
    },
    "team": {
      "title": "Your Local Team, Speaking Your Language",
      "description": "Communicate easily with our Hong Kong-based team in Cantonese, Mandarin, or English."
    },
    "price": {
      "title": "Know Exactly What You're Paying For",
      "description": "Get clear, upfront quotes with no hidden costs - exactly what your budget needs."
    },
    "support": {
      "title": "Your Project Delivered Fast, With Ongoing Support",
      "description": "See your demo in as little as 24 hours and get dedicated support even after your project launches."
    }
  },

  // Services
  "services": {
    "title": "Services For You",
    "subtitle": "Solutions tailored specifically to your unique business needs",
    "viewAllButton": "See All Services",
    "description": "Whatever technology solution you need, delivered at the speed and quality your business deserves.",
    "readMore": "Learn More",
    "whatsIncluded": "What's Included:",
    "features": {
      "appDevelopment": {
        "nativeDevelopment": "Native iOS & Android development",
        "crossPlatform": "Cross-platform solutions (React Native, Flutter)",
        "storeDeployment": "App Store & Play Store deployment",
        "backendIntegration": "Backend integration & APIs",
        "pushNotifications": "Push notifications & real-time features"
      },
      "webDevelopment": {
        "responsiveDesign": "Responsive web design",
        "modernFrameworks": "Modern frontend frameworks",
        "ecommerce": "E-commerce platforms",
        "cms": "Content management systems",
        "seo": "SEO optimization"
      },
      "mobileDevelopment": {
        "customSolutions": "Custom mobile solutions",
        "pwa": "Progressive Web Apps (PWA)",
        "mobileFirst": "Mobile-first design",
        "touchOptimized": "Touch-optimized interfaces",
        "deviceFeatures": "Device-specific features"
      },
      "cloudServices": {
        "infrastructure": "Cloud infrastructure setup",
        "database": "Database design & management",
        "apiDevelopment": "API development & integration",
        "scalableArch": "Scalable architecture",
        "devops": "DevOps & CI/CD pipelines"
      },
      "technicalSupport": {
        "support247": "24/7 technical support",
        "maintenance": "Bug fixes & maintenance",
        "monitoring": "Performance monitoring",
        "security": "Security updates",
        "enhancement": "Feature enhancements"
      },
      "uiUxDesign": {
        "interfaceDesign": "User interface design",
        "uxResearch": "User experience research",
        "wireframing": "Wireframing & prototyping",
        "designSystem": "Design system creation",
        "usability": "Usability testing"
      }
    },
    "appDevelopment": {
      "title": "Custom App Development",
      "shortDescription": "Your ideas transformed into powerful mobile applications for iOS and Android"
    },
    "webDevelopment": {
      "title": "Web Development",
      "shortDescription": "Get a responsive website or web application built with modern technologies"
    },
    "mobileDevelopment": {
      "title": "Mobile Development",
      "shortDescription": "Your mobile solution built natively or cross-platform for all your users' devices"
    },
    "cloudServices": {
      "title": "Cloud Services",
      "shortDescription": "Scalable cloud solutions designed for your business, regardless of size"
    },
    "technicalSupport": {
      "title": "Technical Support",
      "shortDescription": "Ongoing maintenance and support for all your technical requirements"
    },
    "uiUxDesign": {
      "title": "UI/UX Design",
      "shortDescription": "Beautiful, intuitive interfaces designed with your users in mind"
    }
  },

  // Quick Order
  "quickOrder": {
    "pageTitle": "Your Quick Order",
    "pageDescription": "Share what you need and receive your solution and quote within 24 hours.",
    "title": "Tell Us About Your Project",
    "subtitle": "Fill in your details below to get started. You'll hear from us within 24 hours.",
    "serviceTypeLabel": "What type of software do you need?",
    "budgetLabel": "What is your budget range?",
    "countryCodeLabel": "Country Code",
    "phoneLabel": "Phone Number",
    "phonePlaceholder": "Enter your phone number",
    "hkPhoneFormat": "Hong Kong numbers should be 8 digits (e.g., 12345678)",
    "generalPhoneFormat": "Enter your phone number without the country code",
    "emailLabel": "Email (optional)",
    "emailOptional": "Email is optional, but helps us send you a confirmation",
    "descriptionLabel": "Briefly describe your project requirements",
    "descriptionOptional": "Add any details that will help create exactly what you need",
    "charactersUsed": "characters used",
    "submitButton": "Get Your Quote",
    "submitError": "An error occurred. Please try again.",
    "privacyNotice": "By submitting this form, you agree to our Privacy Policy and Terms of Service.",
    "validation": {
      "servicesRequired": "Please select at least one service type",
      "budgetRequired": "Please select your budget range",
      "countryCodeRequired": "Country code is required",
      "phoneRequired": "Phone number is required",
      "phoneInvalid": "Please enter a valid phone number",
      "hkPhoneInvalid": "Hong Kong numbers must be exactly 8 digits",
      "emailInvalid": "Please enter a valid email address",
      "descriptionTooLong": "Description cannot exceed 30,000 characters"
    },
    "success": {
      "title": "Thank You for Your Order!",
      "message": "You'll receive your demo and quotation within 24 hours.",
      "newOrderButton": "Submit Another Order"
    },
    "form": {
      "serviceType": "What type of software do you need?",
      "budget": "What is your budget range?",
      "phone": "Phone Number (required)",
      "email": "Email (optional)",
      "description": "Briefly describe your needs",
      "submit": "Submit",
      "phoneRequired": "Phone number is required",
      "phoneInvalid": "Please enter a valid phone number",
      "emailInvalid": "Please enter a valid email address",
      "success": "You'll hear from us in a few hours",
    },
  },

  // FAQ
  "faq": {
    "title": "Your Questions Answered",
    "more": "Have more questions?",
    "contact": "Contact us",
    "subtitle": "Everything you need to know about working with GamiFly Tech. Can't find what you're looking for? Feel free to reach out!",
    "stats": {
      "demoDelivery": "Demo Delivery",
      "happyClients": "Happy Clients",
      "languagesSpoken": "Languages Spoken",
      "supportAvailable": "Support Available"
    },
    "categories": {
      "general": {
        "title": "General Questions",
        "questions": "questions"
      },
      "pricing": {
        "title": "Pricing & Payment",
        "questions": "questions"
      },
      "timeline": {
        "title": "Timeline & Process",
        "questions": "questions"
      },
      "technical": {
        "title": "Technical Questions",
        "questions": "questions"
      }
    },
    "questions": {
      "general1": {
        "question": "What services does GamiFly Tech provide?",
        "answer": "We provide comprehensive software development services including mobile app development (iOS & Android), web development, cloud services, UI/UX design, and technical support. We specialize in creating custom solutions tailored to your specific business needs."
      },
      "general2": {
        "question": "Do you work with businesses outside Hong Kong?",
        "answer": "Yes! While we're based in Hong Kong, we work with clients globally. Our team is fluent in English, Cantonese, and Mandarin, making communication seamless regardless of your location."
      },
      "general3": {
        "question": "What makes GamiFly Tech different from other development companies?",
        "answer": "We focus on fast delivery (demos within 24 hours), transparent pricing with no hidden costs, local Hong Kong-based team for easy communication, and ongoing support even after project completion. We believe in building long-term partnerships with our clients."
      },
      "general4": {
        "question": "Can you help with both small projects and large enterprise solutions?",
        "answer": "Absolutely! We work with startups needing simple mobile apps to large enterprises requiring complex, scalable solutions. Our team adapts to projects of any size and complexity."
      },
      "pricing1": {
        "question": "How much do your services cost?",
        "answer": "Our pricing varies based on project complexity and requirements. Web development starts from HK$8,000, mobile apps from HK$15,000, and UI/UX design from HK$5,000. Contact us for a detailed quote tailored to your specific needs."
      },
      "pricing2": {
        "question": "Do you offer fixed-price or hourly billing?",
        "answer": "We offer both options depending on your preference and project type. For well-defined projects, we provide fixed-price quotes. For ongoing development or projects with evolving requirements, we offer competitive hourly rates."
      },
      "pricing3": {
        "question": "Are there any hidden costs?",
        "answer": "No hidden costs ever! We provide transparent, upfront pricing that includes all development work, testing, and initial deployment. Any additional costs (like third-party services or hosting) are clearly discussed and approved by you beforehand."
      },
      "pricing4": {
        "question": "What payment methods do you accept?",
        "answer": "We accept bank transfers, PayPal, and major credit cards. For larger projects, we typically work with milestone-based payments to ensure both parties are comfortable throughout the development process."
      },
      "timeline1": {
        "question": "How quickly can you deliver a demo?",
        "answer": "We pride ourselves on fast turnaround times. For most projects, you'll receive an initial demo or prototype within 24 hours of providing your requirements. This helps you visualize the solution before committing to the full development."
      },
      "timeline2": {
        "question": "What is your typical project timeline?",
        "answer": "Timeline depends on project complexity: Simple websites (1-3 weeks), Mobile apps (2-8 weeks), Complex web applications (4-12 weeks), Enterprise solutions (3-6 months). We provide detailed timelines with milestones for every project."
      },
      "timeline3": {
        "question": "Can you work with tight deadlines?",
        "answer": "Yes! We understand business urgency and can often accommodate tight deadlines. We'll assess your requirements and provide an honest timeline. If needed, we can allocate additional resources to meet your launch date."
      },
      "timeline4": {
        "question": "How do you handle project updates and communication?",
        "answer": "We provide regular updates throughout development via your preferred communication method (WhatsApp, email, video calls). You'll have access to a project dashboard showing real-time progress and can request updates anytime."
      },
      "technical1": {
        "question": "What technologies do you use?",
        "answer": "We use modern, industry-standard technologies including React/Vue.js for web, React Native/Flutter for mobile, Node.js/Python for backend, AWS/Google Cloud for hosting, and more. We choose the best tech stack for each project's specific needs."
      },
      "technical2": {
        "question": "Do you provide ongoing maintenance and support?",
        "answer": "Yes! We offer comprehensive maintenance packages starting from HK$3,000/month, including bug fixes, security updates, performance monitoring, and feature enhancements. We believe in supporting your success long-term."
      },
      "technical3": {
        "question": "Is my data and intellectual property secure?",
        "answer": "Absolutely. We implement industry-standard security practices, sign NDAs for all projects, and follow strict data protection protocols. Your code and data remain completely confidential and belong entirely to you."
      },
      "technical4": {
        "question": "Can you integrate with existing systems?",
        "answer": "Yes, we specialize in integrations! Whether it's connecting to your existing CRM, payment systems, databases, or third-party APIs, we ensure seamless integration with your current business tools and workflows."
      }
    },
    "contactSection": {
      "title": "Have more questions?",
      "subtitle": "Our team is here to help! Get in touch with us through your preferred method.",
      "getQuote": "Get Quick Quote",
      "whatsapp": "WhatsApp Us",
      "contact": "Contact Us"
    }
  },

  // Contact
  "contact": {
    "title": "Get In Touch",
    "description": "Have a question or want to discuss your project? We're here to help you build something amazing.",
    "form": {
      "title": "Send us a Message",
      "name": "Your Name",
      "phone": "Phone Number",
      "email": "Email Address",
      "message": "Your Message",
      "submit": "Send Message",
      "sending": "Sending...",
      "success": "Thank you for your message. We'll get back to you within 24 hours.",
      "error": "Something went wrong. Please try again or contact us directly.",
      "emailOptional": "Optional - but helps us send you a confirmation",
      "errors": {
        "nameRequired": "Name is required",
        "phoneRequired": "Phone number is required",
        "phoneInvalid": "Please enter a valid phone number",
        "emailInvalid": "Please enter a valid email address",
        "messageRequired": "Message is required"
      }
    },
    "info": {
      "title": "Contact Information",
      "whatsapp": "WhatsApp",
      "whatsappDesc": "Quick and easy messaging",
      "phone": "Phone",
      "phoneDesc": "Call us directly",
      "email": "Email",
      "emailDesc": "Send us an email",
      "hours": "Business Hours",
      "hoursWeekday": "Monday - Friday: 9:00 AM - 6:00 PM (HKT)",
      "hoursSaturday": "Saturday: 10:00 AM - 4:00 PM (HKT)",
      "hoursSunday": "Sunday: Closed",
      "hoursEmergency": "Emergency support: 24/7 for existing clients",
      "languages": "Languages",
      "langEnglish": "English - Fluent",
      "langCantonese": "Cantonese (廣東話) - Native",
      "langMandarin": "Mandarin (普通話) - Fluent",
      "langNote": "We can communicate in your preferred language"
    }
  },

  // Legal
  "legal": {
    "privacy": "Privacy Policy",
    "terms": "Terms of Service",
  },

  // Common
  "common": {
    "loading": "Loading...",
    "error": "An error occurred. Please try again.",
    "required": "Required",
    "step": "Step",
    "scrollDown": "Scroll Down",
    "next": "Next",
    "back": "Back",
    "submit": "Submit",
    "getQuote": "Get Quote"
  },

  // Language
  "language": {
    "en": "English",
    "zh": "中文",
  },
}; 